






























































































































import { mapActions, mapGetters } from 'vuex'
import { applyCustomErrorConfig, applyCustomErrorConfigOverrides } from '@/custom-errors'
import { trackEvent, SEGMENT_EVENTS } from '@/analytics/segment'
import parseErrorMessage from '@/parse-error-message'
import PageContent from '@/components/PageContent.vue'
import ListStatusBar from '@/components/ListStatusBar.vue'
import Table from '@/components/Table.vue'
import TableNoResults from '@/components/TableNoResults.vue'
import ListPagination from '@/components/ListPagination.vue'
import dataPollingMixin from '@/mixins/data-polling-mixin'
import { IDataPollingOptions } from '@/mixins/data-polling-mixin'
import autoReloadMixin from '@/mixins/auto-reload-mixin'
import MarketplaceFilters from './MarketplaceFilters.vue'
import Sorting from './Sorting.vue'
import RequestDialog from './RequestDialog.vue'
import TermsAndConditions from './TermsAndConditions.vue'
import OrderDetailsDialog from './order-details-dialog/OrderDetailsDialog.vue'
import { OrderDetailAction } from '../marketplace-model'
import MarketplaceOrderRow from './MarketplaceOrderRow.vue'
import OrdersTableTitles from '@/components/OrdersTableTitles.vue'
import AcceptNowConfirmDialog from '@/components/accept-now-confirm-dialog/AcceptNowConfirmDialog.vue'
import AlertModal from '@/components/AlertModal.vue'
import NextLoadSuggestions from '../components/new-design/next-load-suggestions/NextLoadSuggestions.vue'
import ListStatusQuickFilters from '@/components/ListStatusQuickFilters.vue'
import { NextLoadSuggestionsSortBy } from '@/services/models/marketplace-service-model'

export default {
  components: {
    PageContent,
    ListStatusBar,
    ListPagination,
    Table,
    TableNoResults,
    MarketplaceFilters,
    Sorting,
    MarketplaceOrderRow,
    RequestDialog,
    AcceptNowConfirmDialog,
    TermsAndConditions,
    OrderDetailsDialog,
    OrdersTableTitles,
    ListStatusQuickFilters,
    AlertModal,
    NextLoadSuggestions
  },
  mixins: [
    dataPollingMixin(
      'loadMarketplaceOrderUpdates',
      [],
      IDataPollingOptions.getPollingOptions(true)
    ),
    autoReloadMixin('loadOrdersWithQuery')
  ],
  data() {
    return {
      selectedOrderDialogId: null,
      loadingInitially: true,
      selectedOrderId: null,
      nextLoadSuggestionsSortBy: NextLoadSuggestionsSortBy.Nearest,
      nextSuggestionOrderId: null,
      requestDialogOpen: false,
      acceptNowConfirmDialogOpened: false,
      orderDetailsDialogOpen: false,
      isNextLoadSuggestion: false,
      selectedOrder: {}
    }
  },
  computed: {
    ...mapGetters([
      'marketplaceOrders',
      'marketplaceOrdersCount',
      'marketplacePagination',
      'marketplaceFilters',
      'marketplaceOrderUpdatesCount',
      'currentMarketplaceTransportRequestState',
      'nextLoadSuggestions',
      'currentCarrierCompany',
      'currentUser'
    ]),

    isListPaginationVisible(): boolean {
      return !this.listIsEmpty && !this.isRecommendedByBI
    },
    listIsEmpty(): boolean {
      return !this.marketplaceOrders.length && !this.isRecommendedByBI && !this.loading
    },
    isRecommendedByBI(): boolean {
      // Checks if id_for_staff is the ONLY query param present
      const { id_for_staff: idForStaff, ...queryParams } = this.$route.query
      // Checks if at least one of the other query params has a value
      const truthyQueryParam = Object.keys(queryParams).find(param =>
        Boolean(queryParams[param])
      )
      return idForStaff && !truthyQueryParam
    },
    carrierId(): number {
      return this.currentCarrierCompany.id
    },
    isRelevant(): boolean {
      return this.selectedOrder.order ? this.selectedOrder.order.isRelevant : false
    }
  },
  methods: {
    ...mapActions([
      'loadMarketplaceOrders',
      'loadMarketplaceOrderUpdates',
      'submitTransportRequest',
      'triggerReload'
    ]),
    handleCloseDialog() {
      this.trackOrderEvent(SEGMENT_EVENTS.MAO_DIALOG_CLOSED)
      this.clearSelectedOrder()
      this.isNextLoadSuggestion = false
      this.requestDialogOpen = false
    },
    openMakeOfferDialog(orderId) {
      this.setSelectedOrderValue(orderId)
      this.trackOrderEvent(SEGMENT_EVENTS.MAO_BUTTON_CLICK)
      if (this.isNextLoadSuggestion) {
        this.trackNLS(SEGMENT_EVENTS.MAO_NLS_OFFER)
      }
      this.requestDialogOpen = true
      this.isNextLoadSuggestion = false
    },
    handleCloseAcceptNowDialog(stepBack = false): void {
      this.acceptNowConfirmDialogOpened = false
      this.trackOrderEvent(SEGMENT_EVENTS.MAO_ACCEPT_NOW_CONFIRMATION_CLOSED)
      if (stepBack) {
        this.acceptNowConfirmDialogOpened = false
        this.orderDetailsDialogOpen = true
        return
      } else {
        this.isNextLoadSuggestion = false
      }
      this.clearSelectedOrder()
    },
    handleCloseOrderDetail(actionType: OrderDetailAction = null): void {
      if (this.isNextLoadSuggestion) {
        this.trackNLS(SEGMENT_EVENTS.MAO_NLS_CLOSED)
      } else {
        this.trackOrderEvent(SEGMENT_EVENTS.MAO_ORDER_DETAILS_DIALOG_CLOSED)
      }
      this.orderDetailsDialogOpen = false
      if (actionType === OrderDetailAction.AcceptNow) {
        if (this.isNextLoadSuggestion) {
          this.trackNLS(SEGMENT_EVENTS.MAO_NLS_ACCEPTED)
        }
        this.openAcceptNowConfirmDialog(this.selectedOrderId)
        return
      }
      if (actionType === OrderDetailAction.PlaceRequest) {
        this.openMakeOfferDialog(this.selectedOrderId)
      }
      this.isNextLoadSuggestion = false
    },
    openNextSuggestedLoadDetails(orderId: number, sortBy?: NextLoadSuggestionsSortBy) {
      this.$refs.acceptNowAlert.close()
      this.isNextLoadSuggestion = true
      this.nextLoadSuggestionsSortBy = sortBy
      this.openOrderDetailsDialog(orderId)
    },
    openOrderDetailsDialog(orderId: number) {
      if (!orderId) return
      this.setSelectedOrderValue(orderId)
      this.trackOrderEvent(SEGMENT_EVENTS.MAO_ORDER_DETAILS_DIALOG_OPENED)
      this.orderDetailsDialogOpen = true
      this.trackOfferRelevance(this.isRelevant)
    },
    openAcceptNowConfirmDialog(orderId: number) {
      this.setSelectedOrderValue(orderId)
      this.trackOrderEvent(SEGMENT_EVENTS.MAO_ACCEPT_NOW_CLICK)
      this.acceptNowConfirmDialogOpened = true
    },
    openDeepLinkedOrder() {
      const { id_for_staff: idForStaff } = this.$route.query
      if (idForStaff && this.marketplaceOrders.length) {
        const selectOrder = this.findSelectedOrderByIdForStaff(idForStaff)
        this.openOrderDetailsDialog(selectOrder?.order?.id)
      }
    },
    async loadOrdersWithQuery(query) {
      this.loading = true
      this.lastQuery = query
      try {
        await this.loadMarketplaceOrders(query)
        this.openDeepLinkedOrder()
      } catch (err) {
        this.alertModal.showErrorMessage(
          this.$t('marketPlace.error.title'),
          parseErrorMessage(err.message),
          applyCustomErrorConfig
        )
        await this.$router.push(this.$route.path)
      } finally {
        this.loading = false
        this.loadingInitially = false
        this.showMessageIfOrdersListIsEmpty()
      }
    },
    showMessageIfOrdersListIsEmpty() {
      if (this.isRecommendedByBI && !this.marketplaceOrders.length) {
        this.alertModal.showErrorMessage(
          this.$t('marketPlace.orderNotAvailableDialog.title'),
          this.$t('marketPlace.orderNotAvailableDialog.description'),
          applyCustomErrorConfigOverrides({
            allowOutsideClick: false,
            showConfirmButton: true,
            padding: '2em',
            onClose: () => this.$router.push('/marketplace')
          })
        )
      }
    },
    async submitRequest(price, suggestedCost) {
      this.loading = true
      try {
        await this.submitTransportRequest({
          order: this.selectedOrderId,
          price,
          suggested_cost: suggestedCost || null,
          queryParams: this.lastQuery // is outside of the dialog scope
        })

        this.$refs.alertForOffer.open()
      } catch (error) {
        this.alertModal.showErrorMessage(
          this.$t('marketPlace.requestModal.sweetAlert.whoops'),
          this.$t('marketPlace.requestModal.sweetAlert.genericMessage'),
          applyCustomErrorConfig
        )

        this.loadOrdersWithQuery()
      } finally {
        this.loading = false
        this.handleCloseDialog()
      }
    },
    closeAcceptNowAlert() {
      this.nextSuggestionOrderId = null
      this.$refs.acceptNowAlert.close()
    },
    closeAlertForOffer() {
      this.$refs.alertForOffer.close()
    },
    async submittedAcceptNowModal(priceMismatch = false, acceptNowHasFailed = false) {
      if (priceMismatch) {
        await this.loadMarketplaceOrders()
        this.trackOrderEvent(SEGMENT_EVENTS.MAO_SUGGESTED_PRICE_MISMATCHED)
      }
      if (!priceMismatch && !acceptNowHasFailed) {
        this.nextSuggestionOrderId = this.selectedOrderId
        this.$refs.acceptNowAlert?.open()
        this.loadOrdersWithQuery()
      }
      this.loading = false
      this.handleCloseAcceptNowDialog()
    },
    clearSelectedOrder() {
      this.selectedOrder = {}
      this.selectedOrderId = null
    },
    setSelectedOrderValue(orderId) {
      if (!this.isNextLoadSuggestion) {
        this.selectedOrder = this.findSelectedOrder(orderId, this.marketplaceOrders)
      } else {
        this.selectedOrder = this.findSelectedOrder(orderId, this.nextLoadSuggestions)
      }
      this.selectedOrderId = orderId
    },
    findSelectedOrder(orderId, orders) {
      return orders.find(order => order.order.id === orderId) || {}
    },
    findSelectedOrderByIdForStaff(idForStaff) {
      return (
        this.marketplaceOrders.find(item => item.order?.idForStaff === idForStaff) || {}
      )
    },
    trackRefreshEvent(): void {
      trackEvent(SEGMENT_EVENTS.MARKETPLACE_REFRESH_BUTTON_CLICKED, {
        carrierId: this.carrierId
      })
    },
    trackOfferRelevance(isRelevant): void {
      if (isRelevant) {
        trackEvent(SEGMENT_EVENTS.MAO_RELEVANT_OFFER_CLICK, {
          carrierId: this.carrierId,
          orderId: this.selectedOrderId
        })
      } else {
        trackEvent(SEGMENT_EVENTS.MAO_NOT_RELEVANT_OFFER_CLICK, {
          carrierId: this.carrierId,
          orderId: this.selectedOrderId
        })
      }
    },
    trackOrderEvent(eventName): void {
      trackEvent(eventName, {
        carrierId: this.carrierId,
        orderId: this.selectedOrderId,
        isRelevant: this.isRelevant
      })
    },
    trackNLS(eventName): void {
      trackEvent(eventName, {
        carrierId: this.carrierId,
        sortBy: this.nextLoadSuggestionsSortBy,
        orderId: this.nextSuggestionOrderId,
        userId: this.currentUser.id
      })
    }
  }
}
